/**
 * Handing text to the browser as a file.
 *
 * Files from authenticated API calls are built client-side, never linked:
 * a plain link would be requested without the auth header.
 * @module helpers/download
 */

/**
 * Save text as a file, through the browser's own download.
 *
 * @param filename The name the browser offers to save it under.
 * @param text The file's content.
 * @param type Its media type.
 */
export function downloadText(
  filename: string,
  text: string,
  type = 'application/xml',
): void {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  // Attached for the click: some browsers ignore one on a detached anchor.
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Released once the click has been handled, not before it.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
